import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Chart, registerables } from "chart.js";
import { getPerformanceChartConfig } from "../../PerformanceReportHelperLib/performanceChartHelper";
import { TIME_BUCKET_LABELS, LATENESS_LABELS, CHART_TYPES } from "../../PerformanceReportHelperLib/performanceDataHelper";

Chart.register(...registerables);

const PerformanceSingleChart = ({ reportData, type, title }) => {
    const chartRef = useRef(null);
    const chartInstanceRef = useRef(null);
    const companyIdList = useSelector(state => state.companyIdList);

    useEffect(() => {
        if (!reportData || !chartRef.current) return;

        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
            chartInstanceRef.current = null;
        }

        const companyIds = companyIdList?.getCompanyList()?.length > 0
            ? companyIdList.getCompanyList()
            : null;

        const { barData, lineData } = reportData.getAggregatedChartData(type, companyIds);
        const labels = type === CHART_TYPES.LATENESS ? LATENESS_LABELS : TIME_BUCKET_LABELS;

        const canvasCtx = chartRef.current.getContext('2d');
        const config = getPerformanceChartConfig(barData, lineData, title, labels, canvasCtx);

        chartInstanceRef.current = new Chart(chartRef.current, config);

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
                chartInstanceRef.current = null;
            }
        };
    }, [reportData, companyIdList, type, title]);

    return (
        <div className="performance-chart-container">
            <canvas ref={chartRef} />
        </div>
    );
};

export default PerformanceSingleChart;
